import { IPG } from "@/types/summary";

export const formatDocTc = (pg: IPG[]) => {
  return pg
    .map((pItem) => {
      pItem.sc = pItem.sc.map((sItem) => {
        if (!sItem.words.length) return sItem;
        sItem.bt = sItem.words[0].bt;
        sItem.et = sItem.words[sItem.words.length - 1].et;
        sItem.tc = sItem.words.map((wItem) => wItem.word).join("");
        return sItem;
      });
      return pItem;
      // 去掉空段落
    })
};
